export default [
  { value: "consumer", label: "Consumer" },
  { value: "commercial", label: "Commercial" },
];
